export default __webpack_public_path__ + "static/media/Avatar.fedcb850.svg";